/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentModelResponse } from './search-equipment-model-response';


export interface SearchEquipmentModelResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchEquipmentModelResponse> | null;
}

